import React from 'react'
import styled from 'styled-components'

import { formatDateShort } from 'utils/dateUtils'
import { getActiveIntegrationLabel } from 'utils/integrations'
import { URL_CONST } from 'utils/urlConsts'

import { REINTEGRATION_MESSAGE_OPTIONS } from 'containers/Navigation/SystemNotifications/constants'

import NavigationItem from './NavigationItem'

function SystemNotificationsModal({
  className,
  setOnClickCallback,
  setBadgeCount,
  data,
  title,
  integrations,
  onCloseCallback,
}) {
  const getCount = () => {
    const { notifications } = data
    const {
      license_poc,
      license_expired,
      license_warn,
      license_limit_reached,
      mailbox_911_disable_reason,
      is_office365_old_oauth_scope,
      warn_days_to_password_expire,
      re_integration_message,
    } = notifications

    let counter = 0

    if (!license_poc) {
      if (license_expired) counter++
      else if (license_warn) counter++
    }

    if (license_limit_reached) counter++
    if (mailbox_911_disable_reason) counter++
    if (is_office365_old_oauth_scope) counter++
    if (warn_days_to_password_expire) counter++
    if (re_integration_message) counter++

    return counter
  }

  const {
    license_poc,
    license_expired,
    login_expiry,
    license_warn,
    license_expiery,
    mailbox_911_disable_reason,
    is_office365_old_oauth_scope,
    warn_days_to_password_expire,
    license_limit_reached,
    re_integration_message,
  } = data.notifications

  const counter = getCount()

  return (
    <NavigationItem
      className={className}
      setOnClickCallback={setOnClickCallback}
      setBadgeCount={setBadgeCount(getCount())}
      width="305px"
      onCloseCallback={onCloseCallback}
      content={
        <>
          <div className="notif-title">{title}</div>
          {!license_poc && (
            <>
              {license_expired && (
                <div className="notif-container">
                  Your license has expired. Starting from {formatDateShort(login_expiry)} you will
                  not be able to login. Please, contact us at{' '}
                  <a href="mailto:support@ironscales.com">support@ironscales.com</a>.
                </div>
              )}
              {license_warn && (
                <div className="notif-container">
                  Your license will expire on {formatDateShort(license_expiery)}. Please contact us
                  at <a href="mailto:support@ironscales.com">support@ironscales.com</a> to extend
                  your license.
                </div>
              )}
            </>
          )}
          {warn_days_to_password_expire && (
            <div className="notif-container">
              Your Password Will Expire In {warn_days_to_password_expire} Days
              <br />
              <a href={URL_CONST.settings.profile}>Change it</a>.
            </div>
          )}
          {license_limit_reached && (
            <div className="notif-container">
              You have more mailboxes in your
              {` ${getActiveIntegrationLabel(integrations)} `}
              account than in your IRONSCALES license limit.
              <br /> Please <a href="mailto:licenses@ironscales.com">contact us</a> to increase the
              number of protected mailboxes.
            </div>
          )}
          {mailbox_911_disable_reason && (
            <div className="notif-container">
              Your 911 mailbox is currently disabled. Please reconfigure the 911 mailbox in the
              Settings section. Contact us at{' '}
              <a href="mailto:support@ironscales.com">support@ironscales.com</a> for further
              assistance.
            </div>
          )}
          {is_office365_old_oauth_scope && (
            <div className="notif-container">
              We are constantly improving threat detection, please{' '}
              <a href="/office365/consent/">re-integrate your mail server integration</a> to help us
              to better detect suspicious activity and alert you on time. Note: This is optional.
            </div>
          )}
          {re_integration_message && (
            <div
              className="notif-container"
              dangerouslySetInnerHTML={{
                __html: REINTEGRATION_MESSAGE_OPTIONS[re_integration_message],
              }}
            />
          )}
          {counter === 0 && <div className="notif-container">No Notifications</div>}
        </>
      }
    />
  )
}

export default styled(SystemNotificationsModal)`
  .notif-title {
    color: ${(props) => props.theme.primaryColor};
    font-weight: 600;
    font-size: 12px;
    padding: 15px 15px 15px 35px;
    border-bottom: 1px solid #e5e5e5;
    word-break: break-word;
  }
  .notif-container {
    color: ${(props) => props.theme.primaryColor};
    font-size: 11px;
    padding: 10px 35px;
    border-bottom: 1px solid #f2f2f2;
    line-height: 1.5;
    &:last-child {
      border-bottom: none;
    }
    a {
      color: ${(props) => props.theme.secondaryColor};
      font-size: 11px;
    }
  }
`
